var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 3.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.81543H10.3194V4.02232H6.75V1.81543Z",
    fill: "url(#paint0_radial_2092_12354)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02593 4.64041C5.56166 4.64041 6.01829 4.75743 6.39557 4.99134C6.61819 5.12715 6.80231 5.29077 6.95005 5.48043V4.81035H8.54581V10.5827H6.95005V9.90757C6.80228 10.0982 6.61826 10.2637 6.39557 10.4017C6.0183 10.6356 5.56164 10.7522 5.02593 10.7522C4.4827 10.7522 3.99609 10.6259 3.56603 10.3732C3.13598 10.1166 2.79632 9.76024 2.54733 9.3038C2.29834 8.84355 2.17384 8.30769 2.17383 7.69653C2.17383 7.23626 2.24554 6.81921 2.3889 6.44572C2.53224 6.06854 2.73205 5.74595 2.98852 5.47813C3.24506 5.21027 3.5473 5.00483 3.89439 4.86147C4.24143 4.71438 4.61855 4.64042 5.02593 4.64041ZM5.34278 6.23663C5.08628 6.23665 4.85613 6.29692 4.65243 6.41762C4.44877 6.53456 4.28636 6.70224 4.16565 6.92099C4.04492 7.13603 3.98466 7.39471 3.98466 7.69653C3.98467 7.99447 4.045 8.25285 4.16565 8.47161C4.28636 8.6904 4.44875 8.86024 4.65243 8.98097C4.85613 9.0979 5.08628 9.15641 5.34278 9.15643C5.59929 9.15643 5.82942 9.09789 6.03313 8.98097C6.24063 8.86024 6.40471 8.69043 6.52544 8.47161C6.64614 8.25282 6.70688 7.99454 6.70689 7.69653C6.70689 7.39471 6.64616 7.13603 6.52544 6.92099C6.40472 6.70229 6.24055 6.53454 6.03313 6.41762C5.82942 6.29693 5.59928 6.23663 5.34278 6.23663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2588 10.5827H9.40287V4.81035H11.2588V10.5827Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3313 1.81641C10.94 1.81641 11.4338 2.30981 11.4338 2.91847C11.4338 3.52719 10.94 4.02099 10.3313 4.02099C9.72265 4.02093 9.22925 3.52715 9.22925 2.91847C9.22931 2.30984 9.72269 1.81647 10.3313 1.81641Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2092_12354",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3194 2.91887) rotate(-180) scale(3.56939 3.15322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.a6d1fc87f3137ff05baaa57103c780f9.svg";
export { ForwardRef as ReactComponent };